import { useEffect, useState, useContext } from "react"
import { Link as RouterLink } from "react-router-dom"
import DatePicker from "react-datepicker"
import Autocomplete from "react-google-autocomplete"
import PhoneInput from "react-phone-number-input/input"
import { isValidPhoneNumber } from "react-phone-number-input"
import { useDisclosure } from "@chakra-ui/react"
import {
	Button,
	Center,
	Heading,
	FormErrorMessage,
	FormHelperText,
	FormControl,
	FormLabel,
	Input,
	IconButton,
	Image,
	Link,
	RadioGroup,
	Radio,
	Stack,
	Spinner,
	Text,
	Tooltip,
} from "@chakra-ui/react"
import { InfoOutlineIcon } from "@chakra-ui/icons"
import { Select } from "chakra-react-select"
import { query, collection, where, getDocs } from "firebase/firestore"
import { db } from "../firebase"
import { ReactMultiEmail } from "react-multi-email"
import "react-multi-email/dist/style.css"
import "../select.css"
import "../date-picker.css"
import "../email-input.css"
import { UserContext } from "../Contexts/UserContext"
import { Partners } from "../partnershipData"

export const JobRequestGeneralInformation = ({
	formData,
	formError,
	handleChange,
	handleGenericSelectChange,
	clientList,
	setClientList,
	setFormData,
	verifyJobRequestGeneralInformation,
	blackdomeCompanyOptions,
}) => {
	const { userPlus } = useContext(UserContext)
	const [teamMembersSelect, setteamMembersSelect] = useState([])
	const [clientNeeds, setClientNeeds] = useState(false)
	const [pageLoading, setPageLoading] = useState(false)
	const { isOpen, onOpen, onToggle, onClose } = useDisclosure()
	const [focused, setFocused] = useState(false)
	const apiKey = process.env.REACT_APP_GOOGLE_API_KEY

	const partner = Partners.find((p) => p.id === userPlus?.partner)

	const handleOnBehalfOf = (selectedOptions) => {
		setFormData({
			...formData,
			teamMemberId: selectedOptions,
		})
	}
	useEffect(() => {
		setPageLoading(true)
		const getTeamMembers = async () => {
			if (userPlus?.teamId !== null && userPlus?.isAdmin) {
				try {
					// Query users with the specified teamId
					const q = query(
						collection(db, "users"),
						where("teamId", "==", userPlus?.teamId),
						where("userType", "==", "agent")
					)
					const doc = await getDocs(q)

					const teamMembersSelect = doc.docs
						.filter((doc) => doc.get("id") !== userPlus?.id)
						.map((doc) => {
							return { label: doc.get("email"), value: doc.get("id") }
						})
					setteamMembersSelect(teamMembersSelect)
				} catch (error) {
					console.error("Error fetching user emails:", error)
				}
			}
		}
		const getClients = async () => {
			try {
				let q
				if (userPlus?.isAdmin) {
					q = query(
						collection(db, "agentClient"),
						where("teamId", "==", userPlus?.teamId)
					)
				} else {
					q = query(
						collection(db, "agentClient"),
						where("agentId", "==", userPlus?.id)
					)
				}
				const doc = await getDocs(q)
				const chunk = (arr, size) =>
					Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
						arr.slice(i * size, i * size + size)
					)

				const clientIds = doc.docs.map((doc) => doc.data().clientId)
				const clientIdsChunks = chunk(clientIds, 30)
				let clientListCreate = []

				for (const ids of clientIdsChunks) {
					const q2 = query(collection(db, "users"), where("id", "in", ids))
					const doc2 = await getDocs(q2)
					const chunkClientList = doc2.docs.map((doc) => ({
						label: doc.data().email,
						value: doc.data().id,
					}))
					clientListCreate = [...clientListCreate, ...chunkClientList]
				}

				setClientList(clientListCreate)
			} catch (error) {
				console.error("Error fetching client emails:", error)
			}
		}
		getClients()
		getTeamMembers()
		setPageLoading(false)
	}, [userPlus])

	if (pageLoading) {
		return (
			<Center mt="50px">
				<Stack>
					<Spinner m="auto" />
					<Heading size="lg" fontWeight="bold" mt="30px">
						{" "}
						Loading Job Request{" "}
					</Heading>
				</Stack>
			</Center>
		)
	}

	return (
		<>
			<Center
				flexDirection="column"
				maxW="629px"
				margin={{ base: "15px", md: "auto" }}
				gap={3}
			>
				<FormControl isInvalid={formError && formData.locationAddress === ""}>
					<FormLabel>Location Address</FormLabel>
					<Autocomplete
						isInvalid={formError && formData.locationAddress === ""}
						style={{
							width: "100%",
							height: "40px",
							borderRadius: "5px",
							outline: "2px solid transparent",
							border:
								formError && formData.locationAddress === ""
									? "1px solid red"
									: "1px solid #e2e2ea",
							paddingLeft: "15px",
						}}
						apiKey={apiKey}
						onPlaceSelected={(place) => {
							handleGenericSelectChange(
								{ value: place.formatted_address },
								"locationAddress"
							)
						}}
						options={{ types: [] }}
						defaultValue={formData.locationAddress}
					/>
					{formError && formData.locationAddress === "" && (
						<FormErrorMessage>Location address is required.</FormErrorMessage>
					)}
				</FormControl>
				{partner?.id === "BDPS" && userPlus?.userType !== "client" && (
					<>
						<FormControl
							isInvalid={formError && formData.locationAddress === ""}
						>
							<FormLabel>Select Company Name</FormLabel>
							<Select
								border="1px solid #E2E2EA"
								placeholder="Select company name"
								options={blackdomeCompanyOptions}
								name="companyName"
								value={blackdomeCompanyOptions.find(
									(option) => option.value === formData.companyName
								)}
								onChange={(e) => handleGenericSelectChange(e, "companyName")}
							/>
							{formData.companyName === "other" && (
								<Input
									bgColor="white"
									type="text"
									name="companyEnteredName"
									placeholder="Enter company name"
									mt="10px"
									value={formData.companyEnteredName}
									onChange={(e) => {
										handleChange("companyEnteredName", e.target.value)
									}}
								/>
							)}
						</FormControl>
					</>
				)}
				{(userPlus?.userType === "agent" || userPlus?.userType === "TC") && (
					<>
						<FormControl
							isInvalid={formError && formData.clientIds.length === 0}
						>
							<FormLabel>
								{partner ? "Clients (optional)" : "Clients"}
							</FormLabel>
							{partner && (
								<FormHelperText mb="20px">
									{`To share ${partner.jobRequestText} with clients, first `}
									<Link as={RouterLink} to="/invite" color="borderColor">
										send them an invite
									</Link>{" "}
									{`. Once invited, you’ll be able to select them from the dropdown, and they can view their ${partner.jobRequestText} after creating an account.`}
								</FormHelperText>
							)}
							<Select
								isMulti
								border="1px solid #E2E2EA"
								placeholder="Select clients"
								options={clientList}
								name="clientIds"
								value={
									formData.clientIds.length > 0
										? clientList.filter((option) =>
												formData.clientIds.includes(option.value)
										  )
										: null
								}
								onChange={(e) => handleGenericSelectChange(e, "clientIds")}
							/>
							{formError && formData.clientIds === "" ? (
								<FormErrorMessage>Client is required.</FormErrorMessage>
							) : null}
						</FormControl>
						{!userPlus?.partner && (
							<FormControl
								isInvalid={
									formError &&
									formData.clientEmailAddress.length +
										formData.clientIds.length ===
										0
								}
							>
								<FormLabel>
									Add Clients{" "}
									<Tooltip
										label={`Add your clients to organize your job requests by clients. ${
											partner ? partner.name : "Quiplo"
										} will never contact your client without you inviting them. Clients will have access to their job requests and vendor estimates.`}
										fontSize="sm"
										isOpen={isOpen}
									>
										<IconButton
											variant="tooltip"
											height="auto"
											onMouseEnter={onOpen}
											onMouseLeave={onClose}
											onClick={onToggle}
											icon={<InfoOutlineIcon />}
										/>
									</Tooltip>
								</FormLabel>
								<ReactMultiEmail
									placeholder="Enter email address"
									emails={formData.cleintEmailAddress}
									onChange={(_emails: string[]) => {
										handleChange("clientEmailAddress", _emails)
									}}
									autoFocus={false}
									onFocus={() => setFocused(true)}
									onBlur={() => setFocused(false)}
									getLabel={(email, index, removeEmail) => {
										return (
											<div data-tag key={index}>
												<div data-tag-item>{email}</div>
												<span
													data-tag-handle
													onClick={() => removeEmail(index)}
												>
													×
												</span>
											</div>
										)
									}}
								/>
								{formError &&
									formData.clientEmailAddress.length +
										formData.clientIds.length ===
										0 && (
										<FormErrorMessage>
											Client Email Address is required.
										</FormErrorMessage>
									)}
							</FormControl>
						)}
					</>
				)}
				{userPlus?.isAdmin && (
					<FormControl isInvalid={formError && !formData.teamMemberIds}>
						<FormLabel>Submitted on behalf of (optional)</FormLabel>
						<Select
							border="1px solid #E2E2EA"
							placeholder="Select team member"
							options={teamMembersSelect}
							name="teamMemberId"
							value={teamMembersSelect.find(
								(option) => option.value === formData.teamMemberId
							)}
							onChange={(e) => handleOnBehalfOf(e)}
						/>
						{formError && !formData.teamMemberId ? (
							<FormErrorMessage>Team Member is required.</FormErrorMessage>
						) : null}
					</FormControl>
				)}
				<FormControl isInvalid={formError && !formData.estimatedSquareFeet}>
					<FormLabel>Estimated Square Feet</FormLabel>
					<Input
						bgColor="white"
						type="number"
						name="estimatedSquareFeet"
						placeholder="Enter estimated square feet"
						value={formData.estimatedSquareFeet}
						onChange={(e) => {
							handleChange("estimatedSquareFeet", e.target.value)
						}}
					/>
					{formError && !formData.estimatedSquareFeet ? (
						<FormErrorMessage>
							Estimated square feet is required.
						</FormErrorMessage>
					) : null}
				</FormControl>
				{userPlus?.userType === "client" && (
					<>
						<FormControl>
							<FormLabel>Tell us a bit about your situation</FormLabel>
							<RadioGroup
								value={clientNeeds.toString()}
								onChange={(e) => setClientNeeds(e === "true")}
								mb="30px"
							>
								<Stack direction="column">
									<Radio value="false">
										<Text>I’m managing my home right now</Text>
									</Radio>
									<Radio value="true">
										<Text>I’m currently buying or selling a home</Text>
									</Radio>
								</Stack>
							</RadioGroup>
						</FormControl>
					</>
				)}
				{((clientNeeds && userPlus?.userType === "client") ||
					userPlus?.userType !== "client") && (
					<>
						<FormControl
							isInvalid={formError && formData.isPropertyOccupied === null}
						>
							<FormLabel>Is the property occupied?</FormLabel>
							<Select
								colorScheme="white"
								options={[
									{ value: true, label: "yes" },
									{ value: false, label: "no" },
								]}
								name="isPropertyOccupied"
								value={
									formData.isPropertyOccupied === null
										? null
										: formData.isPropertyOccupied
										? { value: true, label: "yes" }
										: { value: false, label: "no" }
								}
								onChange={(e) =>
									handleGenericSelectChange(e, "isPropertyOccupied")
								}
							/>
							{formError && formData.isPropertyOccupied === null && (
								<FormErrorMessage>
									Property occupied status is required.
								</FormErrorMessage>
							)}
						</FormControl>
						{formData.isPropertyOccupied && userPlus?.partner === "BDPS" && (
							<>
								<FormControl>
									<FormLabel>Current Resident Name</FormLabel>
									<Input
										bgColor="white"
										name="currentResidentName"
										placeholder="Enter current resident name"
										value={formData.currentResidentName}
										onChange={(e) => {
											handleChange("currentResidentName", e.target.value)
										}}
									/>
								</FormControl>
								<FormControl>
									<FormLabel>Current Resident Phone Number</FormLabel>
									<PhoneInput
										country="US"
										style={{
											width: "100%",
											height: "40px",
											padding: "0.5rem 0.75rem",
											border:
												formError &&
												(formData.currentResidentPhone === null ||
													(formData.currentResidentPhone &&
														!isValidPhoneNumber(formData.currentResidentPhone)))
													? "1px solid #F05252"
													: "1px solid #CBD5E0",
											borderRadius: "0.375rem",
											outlineColor:
												formData.currentResidentPhone &&
												!isValidPhoneNumber(formData.currentResidentPhone)
													? "#F05252"
													: "#CBD5E0",
										}}
										placeholder="Enter current resident phone number"
										value={formData.currentResidentPhone}
										onChange={(e) => {
											setFormData((prevFormData) => ({
												...prevFormData,
												currentResidentPhone: e,
											}))
										}}
										onFocus={(e) => {
											e.target.style.borderColor = "#4299e1"
											e.target.style.boxShadow =
												"0 0 0 3px rgba(66, 153, 225, 0.1)"
											e.target.style.outlineColor = "#4299e1"
										}}
										onBlur={(e) => {
											e.target.style.borderColor =
												formData.currentResidentPhone &&
												!isValidPhoneNumber(formData.currentResidentPhone)
													? "#F05252"
													: "#CBD5E0"
											e.target.style.boxShadow =
												formData.currentResidentPhone &&
												!isValidPhoneNumber(formData.currentResidentPhone)
													? "0 0 0 1px #F05252"
													: "none"
										}}
									/>
								</FormControl>
								<FormControl>
									<FormLabel>Current Resident Email</FormLabel>
									<Input
										bgColor="white"
										name="currentResidentEmail"
										placeholder="Enter current resident email"
										value={formData.currentResidentEmail}
										onChange={(e) => {
											handleChange("currentResidentEmail", e.target.value)
										}}
									/>
								</FormControl>
							</>
						)}
						<FormControl
							isInvalid={formError && formData.isDealUnderContract === null}
						>
							<FormLabel>Is this a deal under contract?</FormLabel>
							<Select
								border="1px solid #E2E2EA"
								options={[
									{ value: true, label: "yes" },
									{ value: false, label: "no" },
								]}
								name="isDealUnderContract"
								value={
									formData.isDealUnderContract === null
										? null
										: formData.isDealUnderContract
										? { value: true, label: "yes" }
										: { value: false, label: "no" }
								}
								onChange={(e) =>
									handleGenericSelectChange(e, "isDealUnderContract")
								}
							/>
							{formError && !formData.isDealUnderContract ? (
								<FormErrorMessage>
									Property contract status is required.
								</FormErrorMessage>
							) : null}
						</FormControl>
						{formData.isDealUnderContract && (
							<>
								<FormControl
									isInvalid={formError && formData.inspectionPeriod === null}
								>
									<FormLabel>Inspection Period</FormLabel>
									<DatePicker
										placeholderText="Select date"
										selected={formData.inspectionPeriod}
										onChange={(e) => {
											handleChange("inspectionPeriod", e)
										}}
										dateFormat="MM/dd/yyyy"
									/>
									{formError && formData.inspectionPeriod === null ? (
										<FormErrorMessage>
											Inspection date required.
										</FormErrorMessage>
									) : null}
								</FormControl>
								<FormControl isInvalid={formError && !formData.closingDate}>
									<FormLabel>Closing Date</FormLabel>
									<DatePicker
										placeholderText="Select date"
										selected={formData.closingDate}
										onChange={(e) => {
											handleChange("closingDate", e)
										}}
										dateFormat="MM/dd/yyyy"
									/>
									{formError && !formData.closingDate ? (
										<FormErrorMessage>Closing date required.</FormErrorMessage>
									) : null}
								</FormControl>
							</>
						)}
					</>
				)}
				{partner?.id === "BDPS" && (
					<>
						<FormControl>
							<FormLabel display="flex" alignItems="center" gap={2}>
								{" "}
								<Image
									src="/assets/electricity_icon.svg" // Replace with the path to your custom icon
									alt="Electricity Icon"
									boxSize="20px" // Adjust the size of the icon
								/>
								Is Electric on?
							</FormLabel>
							<Select
								border="1px solid #E2E2EA"
								options={[
									{ value: true, label: "yes" },
									{ value: false, label: "no" },
								]}
								value={
									formData.isElectricOn === null
										? null
										: formData.isElectricOn
										? { value: true, label: "yes" }
										: { value: false, label: "no" }
								}
								onChange={(e) => handleGenericSelectChange(e, "isElectricOn")}
							/>
						</FormControl>
						{formData.isElectricOn && (
							<FormControl>
								<Input
									bgColor="white"
									name="electricCompany"
									placeholder="Enter Electric Company Name (optional)"
									value={formData.electricCompany}
									onChange={(e) => {
										handleChange("electricCompany", e.target.value)
									}}
								/>
							</FormControl>
						)}
						<FormControl>
							<FormLabel display="flex" alignItems="center" gap={2}>
								{" "}
								<Image
									src="/assets/water_icon.svg" // Replace with the path to your custom icon
									alt="Gas Icon"
									boxSize="20px" // Adjust the size of the icon
								/>
								Is Water on?
							</FormLabel>
							<Select
								border="1px solid #E2E2EA"
								options={[
									{ value: true, label: "yes" },
									{ value: false, label: "no" },
								]}
								value={
									formData.isWaterOn === null
										? null
										: formData.isWaterOn
										? { value: true, label: "yes" }
										: { value: false, label: "no" }
								}
								onChange={(e) => handleGenericSelectChange(e, "isWaterOn")}
							/>
						</FormControl>
						{formData.isWaterOn && (
							<FormControl>
								<Input
									bgColor="white"
									name="waterCompany"
									placeholder="Enter Water Company Name (optional)"
									value={formData.waterCompany}
									onChange={(e) => {
										handleChange("waterCompany", e.target.value)
									}}
								/>
							</FormControl>
						)}
						<FormControl>
							<FormLabel display="flex" alignItems="center" gap={2}>
								{" "}
								<Image
									src="/assets/gas_icon.svg" // Replace with the path to your custom icon
									alt="Gas Icon"
									boxSize="20px" // Adjust the size of the icon
								/>
								Is Gas on?
							</FormLabel>
							<Select
								border="1px solid #E2E2EA"
								options={[
									{ value: true, label: "yes" },
									{ value: false, label: "no" },
								]}
								value={
									formData.isGasOn === null
										? null
										: formData.isGasOn
										? { value: true, label: "yes" }
										: { value: false, label: "no" }
								}
								onChange={(e) => handleGenericSelectChange(e, "isGasOn")}
							/>
						</FormControl>
						{formData.isGasOn && (
							<FormControl>
								<Input
									bgColor="white"
									name="gasCompany"
									placeholder="Enter Gas Company Name (optional)"
									value={formData.gasCompany}
									onChange={(e) => {
										handleChange("gasCompany", e.target.value)
									}}
								/>
							</FormControl>
						)}
					</>
				)}
				{((clientNeeds &&
					userPlus?.userType === "client" &&
					partner?.id !== "BDPS") ||
					(userPlus?.userType !== "client" && partner?.id !== "BDPS")) && (
					<FormControl
						isInvalid={formError && formData.areUtilitiesOn === null}
					>
						<FormLabel>Are utilities on?</FormLabel>
						<Select
							border="1px solid #E2E2EA"
							options={[
								{ value: true, label: "yes" },
								{ value: false, label: "no" },
							]}
							value={
								formData.areUtilitiesOn === null
									? null
									: formData.areUtilitiesOn
									? { value: true, label: "yes" }
									: { value: false, label: "no" }
							}
							onChange={(e) => handleGenericSelectChange(e, "areUtilitiesOn")}
						/>
						{formError && formData.areUtilitiesOn === null ? (
							<FormErrorMessage>Utility status is required.</FormErrorMessage>
						) : null}
					</FormControl>
				)}
				<Button
					onClick={verifyJobRequestGeneralInformation}
					bgColor="borderColor"
					color="white"
					w="100%"
					mt="10px"
					mb="40px"
				>
					{userPlus.partner === "BDPS" ? "Continue" : "Choose a service"}
				</Button>
			</Center>
		</>
	)
}
